import { CompanyUserChallengeSettingsModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

export class ChallengeSettings extends DomainEntity<CompanyUserChallengeSettingsModelDto> {
    public static from(dto: CompanyUserChallengeSettingsModelDto): ChallengeSettings {
        return new ChallengeSettings(dto);
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get isOobAuthenticationPinRequired() {
        return this.dto.isOobAuthenticationPinRequired ?? false;
    }

    public set isOobAuthenticationPinRequired(value: boolean) {
        this.dto.isOobAuthenticationPinRequired = value;
    }

    public get numberOfOobAttemptsAllowed() {
        return this.dto.numberOfOobAttemptsAllowed ?? 1;
    }

    public set numberOfOobAttemptsAllowed(value: number) {
        this.dto.numberOfOobAttemptsAllowed = value;
    }

    public get isTokenEnabledForChallenges() {
        return this.dto.isTokenEnabledForChallenges ?? false;
    }

    public set isTokenEnabledForChallenges(value: boolean) {
        this.dto.isTokenEnabledForChallenges = value;
    }

    public get numberOfTokenChallengePointAttemptsAllowed() {
        return this.dto.numberOfTokenChallengePointAttemptsAllowed ?? 1;
    }

    public set numberOfTokenChallengePointAttemptsAllowed(value: number) {
        this.dto.numberOfTokenChallengePointAttemptsAllowed = value;
    }

    public get hasSecureTokenAccountId() {
        return this.dto.hasSecureTokenAccountId ?? false;
    }

    public get isChannelLoginTwoFactorAuthenticationEnabled() {
        return this.dto.isChannelLoginTwoFactorAuthenticationEnabled ?? false;
    }

    public set isChannelLoginTwoFactorAuthenticationEnabled(value: boolean) {
        this.dto.isChannelLoginTwoFactorAuthenticationEnabled = value;
    }
}
